import React, { ReactNode } from 'react';
import Navigation from './Navigation';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="app-layout">
      <header>
        <Navigation />
      </header>
      <main className="main-content">{children}</main>
      <footer>
        <p>&copy; {new Date().getFullYear()} Location Tracker</p>
      </footer>
    </div>
  );
};

export default Layout;
